import request from "./request";

// 获取指定地区的「大屏菜单权限」
export const getAreaPermissions = (areaId) => request.get(`../system/menu/permsByArea/${areaId}`);

// 获取用户详细信息
// export const getInfo = (params) => request.get("../system/user/getInfo", params);

export function getInfo (params) {
  return request.get('../system/user/getInfo', params).then(res => res);
}
// 获取季度类型（返回SX三夏 SQ三秋）
export function getSeason () {
  return request.get('/largeScreen/aidispatch/getQuarterType').then(res => res);
}

